<div class="main-wrapper">
    <div class="left-wrap">
        <div class="mess-box">
            <p>{{showMessage}}</p>
        </div>
        <div class="key-box">
            <label>Ur Key</label>
            <span>{{inKey}}</span>
        </div>
    </div>
    <div class="right-wrap">
        <div class="timer">
            <div class="count-value">
                <p>{{remainingDays}}</p>
                <label>Days</label>
            </div>
            <span>:</span>
            <div class="count-value">
                <p>{{remainingHours}}</p>
                <label>Hours</label>
            </div>
            <span>:</span>
            <div class="count-value">
                <p>{{remainingMinutes}}</p>
                <label>Minutes</label>
            </div>
            <span>:</span>
            <div class="count-value">
                <p>{{remainingSeconds}}</p>
                <label>Seconds</label>
            </div>
        </div>
    </div>
</div>